import React, { useState, useEffect } from "react"

const NewPortfolioModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    // Check if the modal has been dismissed in the current session
    const hasDismissed = sessionStorage.getItem("newPortfolioModalDismissed")
    if (!hasDismissed) {
      // Small delay to make it feel smooth after loader finishes
      const timer = setTimeout(() => {
        setIsOpen(true)
      }, 500)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleClose = () => {
    setIsOpen(false)
    sessionStorage.setItem("newPortfolioModalDismissed", "true")
  }

  const handleVisit = () => {
    sessionStorage.setItem("newPortfolioModalDismissed", "true")
    window.open("https://sriram.swiftproject.in/", "_blank", "noopener,noreferrer")
    setIsOpen(false)
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-6 bg-black/75 backdrop-blur-sm animate-modal-fade-in">
      {/* Modal Container - Compact & Minimalist */}
      <div className="relative w-full max-w-[38rem] overflow-hidden rounded-[2rem] bg-gradient-to-b from-[#1e2540] to-[#151a30] p-[2.5rem] text-center shadow-[0_1.5rem_4rem_rgba(0,0,0,0.5)] border border-[#59b2f4]/20 animate-modal-scale-up">
        
        {/* Glow effect */}
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-[#59b2f4]/10 rounded-full blur-3xl pointer-events-none"></div>

        {/* Close Button */}
        <button 
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors duration-200 text-[2rem] focus:outline-none w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10"
          aria-label="Close dialog"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>

        {/* Icon & Title */}
        <div className="flex flex-col items-center mb-4 mt-2">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#59b2f4]/10 text-[#59b2f4] border border-[#59b2f4]/20 mb-3">
            <i className="fa-solid fa-rocket text-[2.2rem] animate-pulse"></i>
          </div>
          <h2 className="text-[2.2rem] font-bold text-white tracking-tight">
            New Portfolio Live!
          </h2>
        </div>

        {/* Message */}
        <p className="text-[1.4rem] text-gray-300 leading-relaxed mb-6 font-poppins px-1">
          A new version of my portfolio has been developed. Explore the updated design and projects!
        </p>

        {/* Highlight Link */}
        <a 
          href="https://sriram.swiftproject.in/" 
          target="_blank" 
          rel="noopener noreferrer"
          onClick={handleVisit}
          className="block mb-6 text-[1.4rem] text-[#59b2f4] hover:underline font-semibold font-poppins"
        >
          sriram.swiftproject.in <i className="fa-solid fa-arrow-up-right-from-square text-[1.1rem] ml-1"></i>
        </a>

        {/* Buttons */}
        <div className="flex gap-3 justify-center">
          <button
            onClick={handleClose}
            className="flex-1 px-5 py-3 rounded-xl border border-white/10 text-gray-300 hover:text-white hover:bg-white/5 active:scale-95 transition-all duration-200 text-[1.35rem] font-semibold"
          >
            Stay Here
          </button>
          <button
            onClick={handleVisit}
            className="flex-[1.5] px-5 py-3 rounded-xl bg-gradient-to-r from-[#59b2f4] to-[#0066ff] text-white font-bold hover:shadow-[0_0_1.5rem_rgba(89,178,244,0.4)] active:scale-95 transition-all duration-200 text-[1.35rem] flex items-center justify-center gap-2"
          >
            Visit New Site
            <i className="fa-solid fa-arrow-right text-[1.2rem]"></i>
          </button>
        </div>
      </div>
    </div>
  )
}

export default NewPortfolioModal
